import type {
  AdminListUsersParams,
  AdminUpdateUserPersonalInfoInput,
} from '../api'
import { api } from '../api'

const adminListUsers = async (
  params: Omit<AdminListUsersParams, 'userType'> & {
    userType?: 'user' | 'agent'
  },
) => {
  return await api.v1.adminListUsers(params as AdminListUsersParams)
}

const adminUpdateUserPersonalInfo = async (
  data: AdminUpdateUserPersonalInfoInput,
) => {
  return await api.v1.adminUpdateUserPersonalInfo(data)
}

export default {
  adminListUsers,
  adminUpdateUserPersonalInfo,
}
